import {useState} from "react";
import {Button, Form, Modal} from "semantic-ui-react";
import {useAppDispatch} from "../../app/hooks";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {ExportServer} from "./ExportActions";
import { useTranslation } from "react-i18next";
interface IDpiModal {
  open: boolean;
  onClose: () => void;
}
export const TemplateNameModal = ({open, onClose}: IDpiModal) => {
  const {companyId} = useSelector((state: RootState) => state.auth);
  const {templates} = useSelector((state: RootState) => state.refData);
  const [templateName, setTemplateName] = useState<string>();
  const [error, setError] = useState<string>("");
  const [overrideModalOpen, setOverrideModalOpen] = useState<boolean>(false);
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const onInputChange = (e: any) => {
    setError("");
    const {value} = e.target;
    setTemplateName(value);
  };

  const onSubmit = () => {
    if (templateName === undefined || templateName === null || templateName === "") {
      setError(t("enter_template_name"));
      return;
    }

    const invalidCharsRegex = /[^a-zA-Z0-9 _!@#$%^&*()+=-]/g;
    if (invalidCharsRegex.test(templateName)) {
      setError(t("template_name_invalid"));
      return;
    }

    if (templateName.length < 2) {
      setError(t("template_name_small"));
      return;
    }

    if (templateName.length > 50) {
      setError(t("template_name_large"));
      return;
    }

    if (templates?.find((t: any) => t.name === templateName)) {
      setOverrideModalOpen(true);
    } else {
      dispatch(ExportServer(companyId, true, templateName));
      onHide();
    }
  };

  const onOverride = () => {
    const overrideRecid = templates?.find((t: any) => t.name === templateName).recid;
    dispatch(ExportServer(companyId, false, templateName, overrideRecid));
    onHide();
  };

  const onHide = () => {
    setTemplateName(undefined);
    setOverrideModalOpen(false);
    setError("");
    onClose();
  };
  return (
    <>
      <ConfirmOverrideModal open={overrideModalOpen} templateName={templateName || ""} onHide={() => setOverrideModalOpen(false)} onOverride={onOverride} />
      <Modal size="tiny" closeIcon onClose={onHide} open={open}>
        <Modal.Header>{t("enter_new_template_name")}</Modal.Header>
        <Modal.Content>
          <Form onSubmit={onSubmit}>
            <Form.Field required>
              <label>{t("name")}</label>
              <Form.Input autoFocus placeholder={t("template_name")} required name="templateName" value={templateName || ""} onChange={onInputChange} error={error !== "" ? {content: error, pointing: "below"} : false} />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" basic onClick={onHide}>
            {t("cancel_btn")}
          </Button>
          <Button color="green" basic type="submit" onClick={onSubmit}>
            {t("save")}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

interface IConfirmOverrideModal {
  open: boolean;
  onHide: () => void;
  onOverride: () => void;
  templateName: string;
}
const ConfirmOverrideModal = ({open, templateName, onHide, onOverride}: IConfirmOverrideModal) => {
  const {t} = useTranslation();
  return (
    <Modal size="mini" closeIcon onClose={onHide} open={open}>
      <Modal.Header>{t("template_name_exists", {templateName})}</Modal.Header>
      <Modal.Actions>
        <Button color="black" basic onClick={onHide}>
          {t("cancel_btn")}
        </Button>
        <Button color="green" basic type="submit" onClick={onOverride}>
          {t("save")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
